export const PRESSION_IMMOBILIERE_OPTION = [
  {
    label: 'Zone à pression Immobilière normale (2019)',
    value: 160353.61
  },
  {
    label: 'Zone à forte pression Immobilière (2019)',
    value: 171043.85
  },
  {
    label: 'Zone à pression Immobilière normale (2018)',
    value: 157087.20
  },
  {
    label: 'Zone à forte pression Immobilière (2018)',
    value: 167559.68
  }
]


// WEBPACK FOOTER //
// ./src/computationApps/data/pression_immobiliere.js